<template>
  <div
    class="sidemenu"
    v-on:click="closeSidemenu()"
  >
    <div
      class="sidemenu__container"
      v-on:click.stop
    >
      <div class='sidemenu__header'>
        <button
          class='sidemenu__close-btn button--no'
          v-on:click='closeSidemenu()'
        >
          <icon name="close" />
        </button>
      </div>
      <div class='sidemenu__content'>
        <offlineSearch class="sidemenu__item" />
        <sound class='sidemenu__item' />
        <user class='sidemenu__item' />
        <languageSelector class="sidemenu__item" />
        <update class="sidemenu__item" />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.sidemenu {
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100vw;
  z-index: 2;
  background: $sidemenu__overlay;
  &__container {
    background: $sidemenu__bg;
    border-left: 1px solid $sidemenu__border-color;
    height: 100%;
    width: 300px;
    margin-left: auto;
  }
  &__title {
    font-weight: 800;
    text-transform: uppercase;
    font-size: 1.3rem;
  }
  &__header {
    display: flex;
    justify-content: flex-end;
    padding: $content;
    border-bottom: 1px solid $sidemenu__border-color;
  }
  &__content {
    display: flex;
    flex-direction: column;
    overflow: auto;
  }
  &__item {
    border-bottom: 1px solid $sidemenu__border-color !important;
  }
}
</style>

<script>
import user from '@/components/app-user.vue'
import sound from '@/components/app-sound.vue'
import update from '@/components/app-lastUpdate.vue'
import languageSelector from '@/components/app-languageSelector.vue'
import offlineSearch from '@/components/app-offlineSearch.vue'

export default {
	name: 'appSidemenu',
	components: {
		user,
		sound,
		update,
		languageSelector,
		offlineSearch
	},
	data () {
		return {
		}
	},
	methods: {
		closeSidemenu () {
			this.$store.dispatch('toggleSidemenu', 'close')
		},
	},
}
</script>
